// extracted by mini-css-extract-plugin
module.exports = {"registration__select-dropdown":"Registration_registration__select-dropdown__32sIi"};